// import TomSelect from "tom-select"
import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { Carousel } from '@fancyapps/ui'
import { initializeEngagementForm, engagementToolTabTitles } from './components/customer-engagement-tool';
// MAIN Content Loaded file
window.addEventListener('DOMContentLoaded', function (e) {
  initializeEngagementForm();
  engagementToolTabTitles();
});
// Get Fancybox going.
Fancybox.bind('[data-fancybox]', {});
const container = document.getElementById("property-gallery");
const sliderPrev = document.getElementById("carousel-prev");
const sliderNext = document.getElementById("carousel-next");
if (container) {
  const options = {
    infinite: false,
    Dots: false,
    Navigation: false,
    on: {
      ready: (instance) => {
        // Current page
        const page = instance.page;
        // Page count
        const pages = instance.pages.length;

        updateCurrentSlide(page);
        updateTotalSlide(pages);
      },
      change: (instance) => {
        // Current page
        const page = instance.page;
        updateCurrentSlide(page);
      },
    },
  };

  const propertyCarousel = new Carousel(container, options);


  sliderPrev.addEventListener("click", (e) => {
    e.preventDefault();
    propertyCarousel.slidePrev(); // call the .slidePrev() function when sliderPrev is clicked
  });

  sliderNext.addEventListener("click", (e) => {
    e.preventDefault();
    propertyCarousel.slideNext(); // call the .slideNext() function when sliderNext is clicked
  });

}
function updateCurrentSlide(currentSlide) {
  document.querySelector('.carousel-control .carousel-ctr .current').innerHTML = currentSlide + 1;
}
function updateTotalSlide(totalSlide) {
  document.querySelector('.carousel-control .carousel-ctr .total').innerHTML = totalSlide;
}


jQuery('select:not(".unselectized"):not(".epl-sort-listings")').selectize({
  plugins: [
    "remove_button",
    "restore_on_backspace",
    "clear_button",
    "auto_position"
  ],
  delimiter: ",",
  persist: false,
  create: function (input) {
    return {
      value: input,
      text: input,
    };
  },
});
let filters_modal = document.getElementById("filters");
if (filters_modal) {

  filters_modal.addEventListener("shown.bs.modal", function () {
    console.log(this);
    var propertyLocation = document.querySelector('#property-search-form #address_search');
    var selectedOption = propertyLocation ? propertyLocation.selectedOptions : [];

    if (selectedOption.length >= 1) {
      this.querySelector('#surroundingSuburbs').disabled = false;
    }
  });
}


document.addEventListener("DOMContentLoaded", () => {
  document.getElementById("toggle").addEventListener("click", () => {
    document.body.classList.toggle("overflow-hidden");

    const fullscreen = document.querySelector(".fullscreen");
    fullscreen.classList.toggle("active");
    fullscreen.classList.remove("reverse_anim");

    const toggleButton = document.getElementById("toggle");
    toggleButton.classList.toggle("active");
  });
  let close = document.querySelector(".close");
  if (close) {
    close.addEventListener("click", () => {
      const fullscreen = document.querySelector(".fullscreen");
      fullscreen.classList.toggle("reverse_anim");
    });
  }
});
document.querySelectorAll('.property-lists a[data-bs-toggle="tab"]').forEach((tabLink) => {
  tabLink.addEventListener('show.bs.tab', function (e) {
    const view = this.getAttribute('data-view');
    const agent = this.getAttribute('data-agent');
    const sortby = this.getAttribute('data-sortby');
    const sort_order = this.getAttribute('data-sort_order');

    const list = this.getAttribute('data-list');
    const tab_view = document.querySelector('.tab-content #' + view);
    const loader_html = '<div class="ratio ratio-16x9"><div class="logo-loader"></div></div>';

    tab_view.innerHTML = loader_html;

    fetch(docs_ajax.url + '?' + new URLSearchParams({
      'action': "featured_properties",
      'view': view,
      'agent': agent,
      'sortby': sortby,
      'sort_order': sort_order,
      'list': list,
    }))
      .then(response => response.text())
      .then(data => {
        tab_view.innerHTML = data;
      })
      .catch(error => {
        console.error(error);
      });
  });
});

let readMoreButtons = document.querySelectorAll('#descriptionReadMore');
if (readMoreButtons) {

  readMoreButtons.forEach(button => {
    button.addEventListener('click', function () {
      const content = this.closest('.card-body'); // Selects the card-body within the same card
      content.classList.toggle('expanded');

      // Update button text
      this.textContent = content.classList.contains('expanded') ? 'Show less' : 'Read more';
    });
  });

}

document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  document.addEventListener('click', function (e) {
    if (e.target.matches('.btn-read-more')) {
      e.target.parentElement.previousElementSibling.classList.remove('testimonial-collapsed');
      e.target.parentElement.remove();
    }
  });
});
const testimonialCarousel = document.getElementById("testimonial-carousel");

if (testimonialCarousel) {
  const sliderPrev = document.getElementById("testimonial-prev");
  const sliderNext = document.getElementById("testimonial-next");
  console.log(sliderPrev);
  console.log(sliderNext);
  const options = {
    infinite: false,
    Dots: false,
    Navigation: false,
    adaptiveHeight: true,
    fill: true,
  };


  const TestimonialCarousel = new Carousel(testimonialCarousel, options);

  sliderPrev.addEventListener("click", (e) => {
    TestimonialCarousel.slidePrev();
  });

  sliderNext.addEventListener("click", (e) => {
    TestimonialCarousel.slideNext();
  });
}
